import { withHttps, type WebhookEndpoint, type WebhookEndpointCreated, type WebhookEvent, type WebhookSend } from "@omnabase/shared";
import { api } from "./api";
import { useFetch } from "./inbox";

/** Settings › Integrations › Webhooks' data (M12 round three): the workspace's webhook addresses from `GET /w/:slug/webhooks`, each one's
 *  log, and the writes. The secret travels once, in the answer to the create; nothing here keeps it. */
export const webhooksUrl = (slug: string) => `/api/v1/w/${slug}/webhooks`;
export function useWebhooks(slug: string, enabled: boolean) {
  return useFetch<{ webhooks: WebhookEndpoint[] }>(enabled ? webhooksUrl(slug) : null);
}
/** the list as Settings › Integrations shares it between its tabs, the Add new cards and the Webhooks section (integrations round three) */
export type WebhooksList = ReturnType<typeof useWebhooks>;
export function useWebhookSends(slug: string, id: string | null) {
  return useFetch<{ sends: WebhookSend[] }>(id ? `${webhooksUrl(slug)}/${id}/sends` : null);
}
export const webhooks = {
  create: (slug: string, body: { url: string; events: WebhookEvent[]; projects: string[] }) => api.post<WebhookEndpointCreated>(webhooksUrl(slug), body),
  enable: (slug: string, id: string, enabled: boolean) => api.patch<{ webhook: WebhookEndpoint }>(`${webhooksUrl(slug)}/${id}`, { enabled }),
  remove: (slug: string, id: string) => api.del<{ ok: true }>(`${webhooksUrl(slug)}/${id}`),
  test: (slug: string, id: string) => api.post<{ sendId: string }>(`${webhooksUrl(slug)}/${id}/test`, {}),
  redeliver: (slug: string, id: string, sendId: string) => api.post<{ ok: true }>(`${webhooksUrl(slug)}/${id}/sends/${sendId}/redeliver`, {}),
};
/** what the Add dialog still needs before "Add webhook" (null: ready); the server checks the address again, with its guard. A bare host
 *  counts with "https://" in front (2026-10-16), as the field shows it on blur and the save sends it */
export function webhookProblem(url: string, events: readonly string[]): string | null {
  const u = withHttps(url);
  if (!u) return "Where should it be sent?";
  let parsed: URL;
  try { parsed = new URL(u); } catch { return "That is not a web address."; }
  if (parsed.protocol !== "https:") return "Only https: a webhook carries customer data.";
  if (!parsed.hostname.includes(".")) return "That host cannot be reached from outside.";
  if (!events.length) return "Pick at least one event.";
  return null;
}
/** the ticket's banner buttons (a reply its site never took) */
export const siteReplies = {
  byMail: (slug: string, number: number, messageId: string) => api.post<{ ok: true }>(`/api/v1/w/${slug}/tickets/${number}/messages/${messageId}/send-by-mail`, {}),
  tryAgain: (slug: string, number: number, messageId: string) => api.post<{ ok: true }>(`/api/v1/w/${slug}/tickets/${number}/messages/${messageId}/try-again`, {}),
};
